import React, { useRef, useState } from 'react';
import Flippy, { BackSide, FrontSide } from 'react-flippy';
import Stack from '@mui/material/Stack';
import CardMedia from '@mui/material/CardMedia';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import useGetStaffLandingUsers from '../../hooks/useGetStaffLandingUsers';
import TeamSection from './components/TeamSection';
import TeamGrid from './components/TeamGrid';
import SecretButton from '../../components/buttons/SecretButton';
import { buildCdnUrl } from '../../helpers';
import { STACK_CENTER_COLUMN_DIRECTION } from '../../constants/mui-components';
import {
  containerStack,
  photoContainer,
  photoStyles,
  secretPhotoContainer,
  flippyStyles,
  flippySideStyles,
  buttonTypography,
} from './styles/our-people.styles';

function OurPeople() {
  const [showGroupPhoto, setShowGroupPhoto] = useState(false);
  const [buttonText, setButtonText] = useState('Ver más');
  const people = useGetStaffLandingUsers();
  const firstPeople = people.slice(0, 12);
  const extendedPeople = people.slice(12);

  const handleViewMore = () => {
    setButtonText(showGroupPhoto ? 'Ver más' : 'Ver menos');
    setShowGroupPhoto(!showGroupPhoto);
    if (showGroupPhoto) {
      window.scrollTo({
        top: document.getElementById('team-section').offsetTop - 100,
        behavior: 'smooth',
      });
    }
  };
  const cardRef = useRef(null);
  const flipCard = () => {
    cardRef.current.toggle();
  };
  const realPhoto = (
    <Stack item sx={photoContainer}>
      <CardMedia
        component="img"
        image={buildCdnUrl('images/team_pictures/new_team_photo.jpeg', {
          width: 1200,
          format: 'webp',
          quality: 85,
        })}
        alt="team"
        style={photoStyles}
      />
    </Stack>
  );
  const secretPhoto = (
    <Stack sx={secretPhotoContainer}>
      <CardMedia
        component="img"
        image={buildCdnUrl('images/team_pictures/halloween-team.jpg', {
          width: 1200,
          format: 'webp',
          quality: 85,
        })}
        style={photoStyles}
        alt="secret_team"
      />
    </Stack>
  );
  return (
    <Stack className={STACK_CENTER_COLUMN_DIRECTION} sx={containerStack}>
      <TeamSection people={firstPeople} />
      {showGroupPhoto && (
        <Stack sx={{ width: '100%', maxWidth: '75rem' }}>
          <TeamGrid people={extendedPeople} />
          <Flippy
            style={flippyStyles}
            flipOnClick={false}
            ref={cardRef}
          >
            <FrontSide style={flippySideStyles}>
              {realPhoto}
            </FrontSide>
            <BackSide style={flippySideStyles}>
              {secretPhoto}
            </BackSide>
          </Flippy>
          <SecretButton
            onClick={() => { flipCard(); }}
          />{' '}
        </Stack>
      )}
      <Button
        id="view-more-button"
        variant="newPrimary"
        onClick={handleViewMore}
        sx={{
          marginTop: showGroupPhoto ? '4rem' : '2rem',
        }}
      >
        <Typography variant="small_3" sx={buttonTypography}>
          {buttonText}
        </Typography>
      </Button>
    </Stack>
  );
}

export default OurPeople;
